import $ from 'jquery'
import _ from 'lodash'
import { get as pageDataGet } from '../../abt-utils/page-data'
import { warn as loggerWarn } from '../../abt-utils/logger'

export function customCriteria (test) {
  var isPageOne = pageDataGet('listPageNum') === 1
  var $items = $('.list-item')
  var isFourItems = $items && $items.length > 3

  if (!isPageOne) {
    loggerWarn('ABT: ' + test.id + ' removed - not page 1')
  } else if (!isFourItems) {
    loggerWarn('ABT: ' + test.id + ' removed - less than 4 items')
  }

  return (isPageOne && isFourItems) ? test : null
}

export function plpView () {
  return $('body').hasClass('plp-grid-view') ? 'grid' : 'list'
}

export function markItems (view, recipe) {
  _.map($('.list-item'), _markItem(view, recipe))
}

function _markItem (view, recipe) {
  return function markItem (el, i) {
    var $el = $(el)
    if (!_itemQualifier(i)) return

    $el.addClass('abt-sponsored')
    _updateLids($el, view + '_' + (i + 1) + '_' + recipe)
  }
}

function _itemQualifier (i) {
  return (i === 3 || (i - 3) % 6 === 0) && i < 22
}

function _updateLids ($el, value) {
  $el.find('a').attr('data-track', value)
}



/*****************
 ** WEBPACK FOOTER
 ** ./src/abt-tests/abt524/shared.js
 ** module id = 19
 ** module chunks = 2
 **/